export default {"src":"/_next/static/media/character-a.mono.3d041fed.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};